import React from 'react';
import { PluginsForm } from '.';
import { usePluginsByID } from 'hooks/SparkBuilder/pluginFunction';

export type PluginsFormType = {
  stepTitle?: string | undefined;
  pluginsID?: string;
  pluginFunctionID?: string | null;
  pluginConnectionID: string | null;
};

type PluginsProps = {
  pluginFunctionID: string | null;
  pluginID: string | null;
  handleContinue: () => void;
};

export default function PluginsFormContainer({
  pluginFunctionID,
  handleContinue,
  pluginID,
}: PluginsProps) {
  const {
    pluginFunctionDropdownOptions,
    plugin: selectedPlugin,
    pluginFunctions,
  } = usePluginsByID(pluginID);

  return (
    <>
      {!!pluginFunctionDropdownOptions && (
        <PluginsForm
          pluginFunctionID={pluginFunctionID}
          selectedPlugins={selectedPlugin}
          pluginFunctionDropdownOptions={pluginFunctionDropdownOptions}
          handleTestClick={handleContinue}
          pluginFunctions={pluginFunctions}
        />
      )}
    </>
  );
}
